import { isArray } from 'lodash-es'

/**
 * Utility function to build a URL with search parameters.
 * @param url the URL to which search parameters will be appended
 * @param params an object containing key-value pairs to be converted into search parameters
 * @returns
 */
export const buildUrlWithSearchParams = (url: string, params: Record<string, string | string[] | number | boolean | null | undefined>) => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      searchParams.set(key, String(value))
    }
    if (isArray(value)) {
      searchParams.set(key, value.join(','))
    }
  })

  return `${url}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
}
